export const reducerTypes = {
  GET_PRODUCTS: "reducer/GET_PRODUCTS",
  GET_DETAILS: "reducer/GET_DETAILS",
};

export const sagaTypes = {
  GET_PRODUCTS: "saga/GET_PRODUCTS",
  GET_DETAILS: "saga/GET_DETAILS",
};
